module.exports = __webpack_public_path__ + "img/ivTest_sub64.0f95069a.jpg";